module.exports = __webpack_public_path__ + "static/media/motorcycle-solid-r.52615c25.svg";